export default __webpack_public_path__ + "static/1284-ee7310cd708328ff526c1b9cbdc9ad1f.gif";